export default "__VITE_ASSET__JY28seO8__"